import router from './router'
import store from './store'
import { ElMessage } from 'element-plus'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { getToken } from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['/login','/oauth','/404'] // no redirect whitelist
function _isMobile() {
  let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  return flag;
}
function _isSupport() {
  return !_isMobile()
}
router.beforeEach(async (to, from, next) => {
  // start progress bar
  NProgress.start()
  if (to.path === '/not-support') {
    next()
  } else if (!_isSupport()) {
    next({ path: '/not-support' })
    NProgress.done()
    return
  }



  // set page title
  document.title = getPageTitle(to.meta.title)

  //临时处理**
  if(import.meta.env.DEV){
      next()
      return
  }

  //******* */

  // determine whether the user has logged in
  const hasToken = getToken()

  if (hasToken) {
    if (to.path === '/login') {
      // if is logged in, redirect to the home page
      next({ path: '/' })
      NProgress.done()
    } else {
      const hasGetUserInfo = store.getters.name
      if (hasGetUserInfo) {
        next()
      } else {
        // try {
        //   // get user info
        //   await store.dispatch('user/getInfo')

        //   next()
        // } catch (error) {
          // remove token and go to login page to re-login
          await store.dispatch('user/resetToken')
          //ElMessage.error(error || 'Has Error')
          next(`/login?redirect=${to.path}`)
          NProgress.done()
        // }
      }
    }
  } else {
    /* has no token*/

    if (whiteList.indexOf(to.path) !== -1) {
      // in the free login whitelist, go directly
      next()
    } else {
      // other pages that do not have permission to access are redirected to the login page.
      next(`/login?redirect=${to.path}`)

      NProgress.done()
    }
  }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
